module.exports = require('./dist/interpret/index');
